import React, { useState } from 'react'
import { APIGetLoggerReportsModel } from '../../models/APIGetLoggerReportsModel';
import moment from 'moment'
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import BatteryInfoDisplay from '../../components/Connections/BatteryInfoDisplay'
import { APIGetLoggerEventsModel } from "models/APIGetLoggerEventsModel";
import SignalGauge from '../Connections/NewSignalGauge'
import { APIGetLoggerConnectionsModel } from "models/APIGetLoggerConnectionsModel";
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
interface Props {
    deviceData: APIGetLoggerReportsModel | null | undefined
    eventData: APIGetLoggerEventsModel
    connectionsData: Array<APIGetLoggerConnectionsModel>
}
const LCLSummaryMobile: React.FC<Props> = ({ deviceData, eventData, connectionsData }) => {
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()

    const [showTransModal, setShowTransModal] = useState<boolean>(false)

    const p = {
        fontSize: "18px"
    }



    return (
        <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ textAlign: "center", width: "100%", display: (isLandscape || isTablet) ? 'flex' : 'block', justifyContent: (isLandscape || isTablet) ? 'space-evenly' : 'inherit' }}>
                    <div>
                        <h3 ><b><FormattedMessage id='Details'/></b></h3>
                        <p style={p}>{`${window.location.hostname.includes('zonelog.net') ? 'ZONELOG: ' : 'CharIOT: '}`}<b>{`${deviceData?.product === 'CHRT' && window.location.hostname.includes('zonelog.net') ? 'ZL-2F-1P' : deviceData?.product}`}</b></p>
                        <p style={p}><FormattedMessage id='Firmware Version'/>: <b>{`${deviceData?.softwareversion}`}</b></p>
                        <p style={{ ...p, color: moment().diff(moment(deviceData?.lastconnection), 'days') > 1 ? 'red' : 'inherit'}}><FormattedMessage id='Last Connected'/>: <b>{`${moment(deviceData?.lastconnection).format('DD MMM YYYY HH:mm:ss')}`}</b></p>
                        <p style={{ ...p, color: moment().diff(moment(deviceData?.lastdatapoint), 'days') > 1 ? 'red' : 'inherit'}}><FormattedMessage id='Last Logging Data'/>: <b>{`${moment(deviceData?.lastdatapoint).format('DD MMM YYYY HH:mm:ss')}`}</b></p>
                        <p style={p}><FormattedMessage id='Last Status Message'/>: <b>{`${moment(deviceData?.laststatusmessage).format('DD MMM YYYY HH:mm:ss')}`}</b></p>
                        <p style={p}><FormattedMessage id='Device Name'/>: <b>{`${deviceData?.loggersiteid}`}</b></p>
                        <p style={p}><FormattedMessage id='Site'/>: <b>{`${deviceData?.sitesitename.length > 20 ? deviceData?.sitesitename.slice(0, 20) + '...' : deviceData?.sitesitename}`}</b></p>
                        <p style={p}>GPS: <b>{`Lat: ${deviceData?.latitude} Lng: ${deviceData?.longitude}`}</b></p>
                    </div>
            
                    {(!isLandscape && !isTablet) && <hr style={{ background: "gray", margin: "30px 0" }} />}
                    <div>
                        <h3 ><b><FormattedMessage id='Connection / Stats'/></b></h3>
                        <p style={{ ...p, color: deviceData?.latestbattery < 3.3 ? 'red' : 'inherit' }}><FormattedMessage id='Battery' /> (V): <b>{`${deviceData?.latestbattery}`}</b></p>
                        <div style={{ display: 'flex', position: 'relative', justifyContent: 'center' }} onClick={():void => setShowTransModal(!showTransModal) }>
                            <p style={{ ...p, color: deviceData && deviceData?.transmissionfrequency > 96 ? 'red' : 'inherit' }}><FormattedMessage id='Transmissions Per Day' />: <b>{`${deviceData?.transmissionfrequency}`}</b></p>
                            {deviceData && deviceData?.transmissionfrequency > 96 && <i className="dx-icon-info" style={{ margin: '0 0 0 5px', color: 'red', fontSize: 22 }}></i>}
                            {showTransModal && <div style={{
                                position: 'absolute',
                                width: 200,
                                background: '#f7f7f7',
                                borderLeft: '10px solid red',
                                bottom: '100%',
                                left: '25%',
                                padding: 10,
                                boxShadow: '2px 2px 10px gray',
                                borderRadius: 10,
                                color: 'black'
                            }}><p style={{fontSize: 18} }>Battery life will be significantly diminished at this transmission rate</p>
                                <FullWidthMobileButton disabled={false} text='close' color='error' onClick={():void => setShowTransModal(false) } />
                            </div>}
                        </div>
                        <p style={p}><FormattedMessage id='Internal Temperature'/> (C): <b>{`${deviceData?.temperature}`}</b></p>
                        <p style={p}><FormattedMessage id='Signal'/>: <b>{`${deviceData?.latestsignal}`}</b></p>
                        <p style={p}><FormattedMessage id='Network Type'/>: <b>{`${deviceData?.networktype}`}</b></p>
                        <p style={p}><FormattedMessage id='Carrier'/>: <b>{`${deviceData?.carrier}`}</b></p>
                        <p style={p}><FormattedMessage id='Cell Id'/>: <b>{`${deviceData?.cellId}`}</b></p>
                        <p style={p}><FormattedMessage id='Band'/>: <b>{`${deviceData?.band}`}</b></p>
                        <p style={p}><FormattedMessage id='Coverage Class'/>: <b>{`${deviceData?.coverageclass}`}</b></p>
                        <p style={p}><FormattedMessage id='Energy Level'/>: <b>{`${deviceData?.energylevel}`}</b></p>
                    </div>
                        {(!isLandscape && !isTablet) && <hr style={{ background: "gray", margin: "30px 0 10px 0" }} />}
                        {(!isLandscape && !isTablet) && eventData && deviceData?.product !== 'CHAR-WR' && <div style={{display: "flex", justifyContent: "center"} }>
                        <BatteryInfoDisplay eventData={eventData} startDate={deviceData?.initialConfigDate} />
                    </div>}
                        {(!isLandscape && !isTablet) && <hr style={{ background: "gray", margin: "30px 0 10px 0" }} />}
                        {(!isLandscape && !isTablet) && connectionsData && <div>
                        <SignalGauge connectionsData={connectionsData} />
                    </div>}
                </div> 
            </div>
            {(isLandscape || isTablet) &&
                <div>
                    <hr style={{ background: "gray", margin: "30px 0 10px 0" }} />
                    <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                        {eventData && deviceData?.product !== 'CHAR-WR' && <div style={{ display: "flex", justifyContent: "center" }}>
                            <BatteryInfoDisplay eventData={eventData} startDate={deviceData?.initialConfigDate } />
                    </div>}
                    {connectionsData && <div>
                        <SignalGauge connectionsData={connectionsData} />
                    </div>}
                    </div>
                </div>
                }
        </div>
    )
}
export default LCLSummaryMobile